import { DesignTokens, GivelifyButton, GivelifyIcon } from '@givelify/ui';
import { styled } from '@mui/material';

export const EnvelopesContainer = styled('div')(({ theme }) => ({
    width: '100%',
    marginBottom: 32,
    marginTop: 24,
    [theme.breakpoints.down('mobile')]: {
        marginTop: theme.spacing(5),
        padding: theme.spacing(0, 2, 0, 2),
    },
}));

export const BtnReorder = styled(GivelifyButton)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.down('mobile')]: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            fontSize: 24,
        },
    },
}));

export const ShowTitle = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const EnvelopesListContainer = styled('div')({
    marginTop: '24px',
});

export const NoItemsPanelWrapper = styled('div')({
    minHeight: 180,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: DesignTokens.color.backgroundPrimary,
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: DesignTokens.border.borderComponentDisabled.color,
    borderRadius: 8,
    padding: 16,
});

export const GivingMoneyIcon = styled(GivelifyIcon)({
    marginBottom: '8px',
});
